// src/pages/Upload/uploadStore.js
import React from "react";

const initial = {
  valuationDoc: null,
  legalFeesDoc: null,
  lastUpdatedAt: 0,
};

const Ctx = React.createContext({
  state: initial,
  setDocs: (_partial) => {},
  clearDocs: () => {},
});

function readSession() {
  try {
    const raw = sessionStorage.getItem("__ds_upload_docs__");
    if (!raw) return initial;
    const parsed = JSON.parse(raw);
    return { ...initial, ...parsed };
  } catch {
    return initial;
  }
}
function writeSession(obj) {
  try {
    sessionStorage.setItem(
      "__ds_upload_docs__",
      JSON.stringify({
        valuationDoc: obj.valuationDoc
          ? { name: obj.valuationDoc.name, size: obj.valuationDoc.size }
          : null,
        legalFeesDoc: obj.legalFeesDoc
          ? { name: obj.legalFeesDoc.name, size: obj.legalFeesDoc.size }
          : null,
        lastUpdatedAt: Date.now(),
      })
    );
  } catch {}
}

export function UploadProvider({ children }) {
  const [state, setState] = React.useState(initial);

  React.useEffect(() => {
    const s = readSession();
    setState((prev) => ({ ...prev, ...s }));
  }, []);

  const setDocs = React.useCallback((partial) => {
    setState((prev) => {
      const next = { ...prev, ...partial, lastUpdatedAt: Date.now() };
      writeSession(next);
      return next;
    });
  }, []);

  const clearDocs = React.useCallback(() => {
    setState(initial);
    try {
      sessionStorage.removeItem("__ds_upload_docs__");
    } catch {}
  }, []);

  const value = React.useMemo(() => ({ state, setDocs, clearDocs }), [state, setDocs, clearDocs]);
  return <Ctx.Provider value={value}>{children}</Ctx.Provider>;
}

export function useUploadStore() {
  return React.useContext(Ctx);
}
